import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { filter, map, shareReplay } from 'rxjs/operators';
import { BkLayout } from '@uibakery/kit';
import { NbSidebarService } from '@nebular/theme';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  isAuthenticated$: Observable<boolean>;

  onMenuItemClick(event: any): void {
    console.log('Menu item clicked:', event.item.title);
    if (event.item.title === 'Logout') {
      console.log('Attempting to logout');
      this.authService.logout();
    }
  }

  defaultLayout: BkLayout = {
    paddings: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingTopUnit: 'px',
      paddingRightUnit: 'px',
      paddingBottomUnit: 'px',
      paddingLeftUnit: 'px'
    },
    header: true,
    sidebar: true
  };

  layout$: Observable<BkLayout> = this.router.events
    .pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let route = this.router.routerState.root;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot.data['layout'] || this.defaultLayout;
      }),
      shareReplay(),
    );

  padding$: Observable<string> = this.layout$
    .pipe(
      map((layout: BkLayout) => this.getPaddingCssValue(layout.paddings)),
    );
  
    showSidebar$: Observable<boolean>;

    items =   [
    {
      'title': 'Dashboard',
      'link': '/overview',
      'icon': 'book-open',
      'children': [
        {
          'title': 'Dashboard',
          'link': '/overview/vehicles-overview',
          'children': null
        },
        {
          'title': 'Real Time',
          'link': '/overview/real-time-data',
          'children': null
        },
        {
          'title': 'Analytics',
          'link': '/analytics',
          'children': null
        }
        // {
        //   'title': 'Events',
        //   'link': '/overview/events',
        //   'children': null
        // },
      ]
    },
    {
      'title': 'EV Bikes',
      'link': '/vehicles',
      'icon': 'flash',
      'children': [
        {
          'title': 'Bike Summary',
          'link': '/vehicles/vehicles-list',
          'children': null
        },
        {
          'title': 'Assign Bikes',
          'link': '/vehicles/vehicles-assignment',
          'children': null
        },
        {
          'title': 'Bike Details',
          'link': '/vehicles/vehicle-details',
          'children': null
        },
      ]
    },
    {
      'title': 'Trips',
      'link': '/trips',
      'icon': 'map',
      'children': [
        {
          'title': 'Trip Summary',
          'link': '/trips/trips-overview',
          'children': null
        },
        {
          'title': 'Trip Schedule',
          'link': '/trips/schedule-trip',
          'children': null
        },
        {
          'title': 'Assign a Trip',
          'link': '/trips/trip-assignment',
          'children': null
        },
      ]
    },
    {
      'title': 'Maintenance',
      'link': '/maintenance',
      'icon': 'settings-2',
      'children': [
        {
          'title': 'Maintenance Planner',
          'link': '/maintenance/maintenance-planner',
          'children': null
        },
        {
          'title': 'Maintenance History',
          'link': '/maintenance/history',
          'children': null
        }
      ]
    },
    {
      'title': 'Batteries',
      'link': '/404error',
      'icon': 'battery',
      'children': [
        {
          'title': 'Battery Summary',
          'link': '/404error',
          'children': null
        },
        {
          'title': 'Battery Health',
          'link': '/404error',
          'children': null
        },
        {
          'title': 'Battery Swapping',
          'link': '/404error',
          'children': null
        },
      ]
    },
    {
      'title': 'GEO-Fencing',
      'link': '/404error',
      'icon': 'grid',
      'children': [
        {
          'title': 'Set Boundary',
          'link': '/404error',
          'children': null
        },
        {
          'title': 'View Fencing Limits',
          'link': '/404error',
          'children': null
        }
      ]
    },
    {
      'title': 'Safety',
      'link': '/404error',
      'icon': 'alert-circle',
      'children': [
        {
          'title': 'Control',
          'link': '/404error',
          'children': null
        },
        {
          'title': 'SOS/Alerts',
          'link': '/404error',
          'children': null
        },
        {
          'title': 'Incident History',
          'link': '/404error',
          'children': null
        },
        
      ]
    },
    {
      'title': 'Logout',
      'icon': 'log-out',
      'link': '/logout', // Use a special route that doesn't exist
      'children': null
    }
  ];

  constructor(private router: Router, private sidebarService: NbSidebarService,private authService: AuthService) {
  }

  ngOnInit() {
    // Get authentication status from the AuthService
    this.isAuthenticated$ = this.authService.isAuthenticated();

    this.isAuthenticated$.subscribe(isAuth => {
      console.log('Authentication state:', isAuth);
    });
    
    // Combine layout settings with authentication status
    this.showSidebar$ = combineLatest([
      this.layout$.pipe(map(layout => layout.sidebar)),
      this.isAuthenticated$
    ]).pipe(
      map(([sidebarEnabled, isAuthenticated]) => sidebarEnabled && isAuthenticated)
    );
  }

  toggleSidebar() {
    this.sidebarService.toggle(true);
  }

  private getPaddingCssValue(paddings): string {
    return `${paddings.paddingTop}${paddings.paddingTopUnit} ` +
           `${paddings.paddingRight}${paddings.paddingRightUnit} ` +
           `${paddings.paddingBottom}${paddings.paddingBottomUnit} ` +
           `${paddings.paddingLeft}${paddings.paddingLeftUnit}`;
  }
}
